import { useState } from "react";
import { PortableTextBlock } from "sanity";
import Button from "src/components/button/Button";
import MainText from "src/components/richtext/MainText";
import styled from "src/lib/styles/css";

//#region [Props]
type ArticleSummaryProps = {
    summary?: PortableTextBlock[];
    className?: string;
};
//#endregion

//#region [Component]
export default function ArticleSummary({ summary, className }: ArticleSummaryProps) {
    const [showAll, setShowAll] = useState(false);
    if ((summary?.length ?? 0) === 0) {
        return null;
    }
    return <SArticleSummary className={className}>
        <SContainer>
            <SSummaryHeading>Oppsummering av saken</SSummaryHeading>
            <SSummaryList >
                <SMainText mainText={summary} className={showAll ? "showAll" : ""} />
            </SSummaryList>
            {!showAll && summary!.length > 1 && <SSummaryButton text="Vis mer" isLarge onClick={() => setShowAll(true)} />}
        </SContainer>

    </SArticleSummary>;
}
//#endregion

//#region [Styles]
const SArticleSummary = styled.div`
    margin: 0 auto 0 auto;
    width: 100%;

    padding-bottom: 1em;
`;

const SContainer = styled.div`
    border-radius: 8px;
    background-color: var(--palette-lilla4);
    padding: 10px;
    position: relative;

    @media (min-width: 550px) {
        padding: calc(10px * 2);
    }

`;

const SSummaryHeading = styled.h2`
    text-align: center;
    @media (min-width: 550px) {
        text-align: left;
    }


`;

const SSummaryList = styled.div`
    margin-top: 1em;
    /*margin-bottom: 2em;*/


`;

const SMainText = styled(MainText)`



    &:not(.showAll) {
        max-height: calc(5em * 1.1);
        overflow: hidden;
        position: relative;

        &:after {
            content: "";
            background: linear-gradient(to bottom, #231a4100 0%, #231a4100 75%, #231a41FF 90%);
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }


    * {
        font-size: 0.8rem;
    }

    li::marker {
        content: "⬤   ";
        color: var(--palette-rosa);
        font-size: 1.1em;
    }
`;


const SSummaryButton = styled(Button)`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
`;
//#endregion